.box {
  padding: var(--sp-6) var(--sp-5);
  border-radius: var(--r-lg);
}

.reading { width: 100%; }

/* Золотая нить — та же, что вверху шторок. Связывает блок с рамкой карты. */
.divider {
  width: 100%;
  height: 1px;
  background: var(--c-grad-hairline);
}
